// extracted by mini-css-extract-plugin
export var Description = "L_cp";
export var EditorialGuidelines = "L_ck";
export var GuideLines = "L_cq";
export var Title = "L_cn";
export var container = "L_cl";
export var leftColumn = "L_cm";
export var rightColumn = "L_cr";